export default __webpack_public_path__ + "static/media/gg.30f47622.svg";